module.exports = __webpack_public_path__ + "static/determined-site-header-pridecenter-99ab89a63a82ea187a765424330ca45f.jpg";